import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { SearchComponent } from "@layerswap/ui-kit/components";
import { useSettingsState } from "../../../context/settings";
const RouteSearch = ({ searchQuery, setSearchQuery, shouldFocus, direction }) => {
    const { sourceRoutes, destinationRoutes } = useSettingsState();
    const routes = useMemo(() => direction === 'from' ? sourceRoutes : destinationRoutes, [direction, sourceRoutes, destinationRoutes]);
    const animatedPlaceholders = useMemo(() => {
        const shuffled = [...routes].sort(() => Math.random() - 0.5);
        const routeTexts = shuffled
            .filter((route) => route.tokens?.length)
            .map((route) => {
            const token = route.tokens[Math.floor(Math.random() * route.tokens.length)];
            return `Try "${token.asset} ${route.display_name || route.name}"`;
        });
        return ["Search by token and network", ...routeTexts];
    }, [routes]);
    return _jsx("div", { children: _jsx(SearchComponent, { searchQuery: searchQuery, setSearchQuery: setSearchQuery, isOpen: shouldFocus, animatedPlaceholders: animatedPlaceholders }) });
};
export default RouteSearch;
